<template>
  <div>
    <main-layout>
      <v-container>
        <v-layout>
          <v-flex>
            <h3 class="headline">{{ $t('Comment to Inbox') }}</h3>
          </v-flex>
          <v-flex class="text-xs-right">
            <transfer-intent type="replycomment" :intents="intents"></transfer-intent>
          </v-flex>
        </v-layout>

        <v-layout v-if="intents.length > 1">
          <v-flex xs12 sm6 class="form-control">
            <input
              type="text"
              v-model.lazy="search"
              class="form-control"
              :placeholder="$t('Search Comment to inbox')"
              style="margin-bottom: 10px"
            />
          </v-flex>
          <v-flex xs12 sm6 class="text-xs-right">
            <v-btn outline color="primary" @click="expandAll">
              <em class="fas fa-expand-arrows-alt mr-1" />
              {{ $t('Expand All') }}
            </v-btn>
            <v-btn outline color="primary" @click="collapseAll">
              <em class="fas fa-compress mr-1" />
              {{ $t('Collapse All') }}
            </v-btn>
          </v-flex>
        </v-layout>

        <div>
          <div style="margin-bottom: 10px">
            <a href="javascript:void(0);" v-if="!isShow" @click="addCommentToInbox">
              <div class="add-conversation text-xs-center">
                <em class="fa fa-plus middle" />
                {{ $t('Add Comment to inbox') }}
              </div>
            </a>

            <div class="intent-item z-border-red" v-else style="padding: 10px 15px 0px">
              <manage-intent
                :isCommentToInbox="true"
                :type="'add'"
                v-model="intent"
                @close="onClose"
                @saveIntent="onSaveIntent"
                :excludedIntentName="excludedIntentName"
              ></manage-intent>
            </div>
          </div>
          <!-- <transition-group
            v-bind:css="false"
            v-on:before-enter="beforeEnter"
            v-on:enter="enter"
            v-on:leave="leave"
          > -->
          <intent-item
            v-for="(item, index) in filterIntents"
            :isCommentToInbox="true"
            :filterIntents="filterIntents"
            :key="'intent_' + item.id + '_' + index"
            v-model="filterIntents[index]"
            @onDelete="deleteIntent(index)"
            @onCopyIntent="copyIntent"
            :excludedIntentName="excludedIntentName"
            @onUpdate="onUpdateIntent"
          ></intent-item>
          <!-- </transition-group> -->
        </div>
      </v-container>
      <v-divider></v-divider>

      <div style="position: relative">
        <v-container>
          <!-- <v-premium-plan-popup
            :showAll="false"
            v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          ></v-premium-plan-popup> -->
          <h3 class="headline">{{ $t('More Comment to Inbox') }}</h3>
          <transition name="fade">
            <div class="col s12" v-if="default_comment_to_inbox">
              <intent-item
                :isCommentToInbox="true"
                v-model="default_comment_to_inbox"
                :isDefault="true"
                @onDelete="deleteIntent(index)"
                :excludedIntentName="excludedIntentName"
                @onUpdate="onUpdateIntent"
              ></intent-item>
            </div>
          </transition>
        </v-container>
      </div>
      <div class="mt-5 mb-5"></div>
    </main-layout>
  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import TransferIntent from './TransferIntent'
import { mapGetters } from 'vuex'
import manageIntent from './intent-manage'
import intentItem from './intent-item'
import api from '@/api'
import ModalDialog from '@/components/elements/ModalDialog'
import ModalHelp from '@/components/elements/ModalHelp'
export default {
  components: {
    'manage-intent': manageIntent,
    'intent-item': intentItem,
    ModalDialog,
    ModalHelp,
    TransferIntent
  },
  data() {
    return {
      isShow: false,
      showModal: false,

      intent: {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      },
      allIntents: [],
      intents: [],
      search: '',
      welcome_message: {
        message: '',
        generics: [],
        type: '',
        quick_reply: []
      },
      isSave: false,
      lastedIntentName: '',
      default_comment_to_inbox: undefined
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    filterIntents: function () {
      var vm = this
      if (vm.selectedBot.theme !== 'tero') {
        vm.intents.sort(function (a, b) {
          var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
          var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
          if (a.intentname[0] === '{' && a.intentname[a.intentname.length - 1] === '}') {
            return 1
          }
          if (b.intentname[0] === '{' && b.intentname[b.intentname.length - 1] === '}') {
            return -1
          }
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
      }

      return vm.intents.filter((intent) => {
        var isFound =
          (intent.intentname.toLowerCase().includes(vm.search.toLowerCase()) ||
            intent.q_val.toLowerCase().includes(vm.search.toLowerCase()) ||
            intent.a_val.toLowerCase().includes(vm.search.toLowerCase())) &&
          intent.context_in === 'comment'
        return isFound
      })
    },
    excludedIntentName: function () {
      var result = []
      var vm = this
      if (vm.allIntents) {
        vm.allIntents.map(function (intent, index) {
          result.push(intent.intentname)
        })
      }
      return result.join(',')
    },
    totalIntentWithoutDefault() {
      var intentwithoutwelcome = this.intents.filter((el) => {
        return !['{welcome}', '{default}', '{default_comment_to_inbox}', '{default_live}'].includes(
          el.intentname
        )
      })
      return intentwithoutwelcome.length
    }
  },
  mounted: function () {
    var vm = this

    vm.$store.dispatch('loading')
    vm.getWelcomeMessage(function () {
      vm.getIntent(function () {
        vm.$store.dispatch('loading')
      })
    })
    if (this.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    if (vm.$store.state.toaPaintPage.includes(vm.selectedBot.pageid)) {
      vm.$store.dispatch('loadGroupConversation')
    }
    vm.$store.dispatch('loadSetting')
  },
  methods: {
    beforeEnter: function (el) {
      el.style.opacity = 0
      // el.style.height = 0;
    },
    enter: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 1 }, { complete: done })
      }, delay)
    },
    leave: function (el, done) {
      var delay = el.dataset.index * 250
      setTimeout(function () {
        Velocity(el, { opacity: 0 }, { complete: done })
      }, delay)
    },
    onSaveIntent: function (payload) {
      // console.log(JSON.parse(payload.a_val))
      var vm = this
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      vm.isShow = false
      payload.isShow = true
      vm.intents.push(payload)
      vm.allIntents.push(payload)
      vm.intent = {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: [[]],
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true
      }
      vm.lastedIntentName = payload.intentname
      vm.isSave = true
      vm.onClose()
      vm.isSave = false
      vm.$swal.fire({
        title:
          vm.$t('conversation') +
          ' "' +
          payload.intentname.replace(/\<|\>/g, '') +
          '" ' +
          vm.$t('added'),
        type: 'success',
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
    },
    copyIntent: function (payload) {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 2) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</strong>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade')
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault.length >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t('Please contact us')}</strong>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        payload.onCopy().then((result) => {
          result.isShow = true
          this.intents.push(result)
          this.allIntents.push(result)
          var vm = this
          vm.$swal.fire({
            title:
              vm.$t('conversation') +
              ' "' +
              result.intentname.replace(/\<|\>/g, '') +
              '" ' +
              vm.$t('added'),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            cancelButtonText: vm.$t('cancel'),
            reverseButtons: true
          })
        })
      }
    },
    onClose: function (payload) {
      this.$store.commit('REMOVE_EDITTING_INTENT', 'ADD_INTENT')
      this.isShow = false
    },
    getIntent: function (callback) {
      let vm = this
      let auth = null
      let data = {
        pageid: vm.selectedBot.pageid
      }
      api.getIntent(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          var intents = response.data.map(function (val) {
            var intent = { ...val }
            intent.isShow = false
            intent.ableToDelete = true
            return intent
          })
          vm.allIntents = intents
          vm.intents = intents.filter((el) => {
            return (
              el.context_in == 'comment' &&
              el.intentname != '{default_comment_to_inbox}' &&
              el.intentname != '{welcome}'
            )
          })

          var default_comment_to_inbox = intents.find((el) => {
            return el.intentname == '{default_comment_to_inbox}'
          })

          if (default_comment_to_inbox) {
            default_comment_to_inbox.ableToDelete = false
            vm.default_comment_to_inbox = default_comment_to_inbox
          } else {
            vm.default_comment_to_inbox = {
              intentname: '{default_comment_to_inbox}',
              q_type: 'text',
              a_type: 'json',
              q_val: '{default}',
              a_val: [[]],
              context_in: '',
              context_out: '',
              ableToDelete: false,
              isShow: false,
              pageidlist: '',
              userstatus: '',
              usertags: '',
              linenoti_status: false,
              linenoti_text: null,
              starttime: null,
              endtime: null,
              intentstatus: true
            }
          }
        }
        callback()
      })
    },
    deleteIntent: function (index) {
      let vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.filterIntents[index].intentname.replace(/\<|\>/g, '')
          }),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            let data = {
              id: vm.filterIntents[index].id,
              pageid: vm.selectedBot.pageid
            }
            vm.$store.dispatch('loading')
            api.deleteIntent(data, function (error, response) {
              if (error) {
                console.error(error)
                vm.$store.dispatch('loading')
                return
              }

              $.each(vm.intents, function (intent_index, intent) {
                if (intent.id == data.id) {
                  vm.intents.splice(intent_index, 1)
                  return false
                }
              })

              if (vm.allIntents) {
                var findIndex = vm.allIntents.find(function (el) {
                  return el.id == data.id
                })

                if (findIndex > -1) {
                  vm.allIntents.splice(findIndex, 1)
                }
              }
              vm.$store.dispatch('loading')
            })
          }
        })
    },
    addCommentToInbox() {
      if (this.$store.getters.getPackage != 'premium' && this.totalIntentWithoutDefault >= 2) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t(
              'if you want to add more conversation, <br/>please upgrade to premium'
            )}</strong>`,
            confirmButtonText: this.$t('Upgrade now'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              this.$router.push('Upgrade')
            }
          })
      } else if (
        this.$store.getters.getPackage == 'premium' &&
        this.totalIntentWithoutDefault >= 300 &&
        !this.$store.state.UnlimitedConversation.includes(this.selectedBot.pageid) &&
        this.selectedBot.pagetype !== 'enterprise'
      ) {
        this.$swal
          .fire({
            html: `<strong class="intentmax"> ${this.$t('Please contact us')}</strong>`,
            confirmButtonText: this.$t('Contact us'),
            confirmButtonColor: this.$vuetify.theme.primary
          })
          .then((result) => {
            if (result.value) {
              window.location.assign('https://www.facebook.com/messages/t/zwizai')
            }
          })
      } else {
        this.$store.commit('ADD_EDITTING_INTENT', 'ADD_INTENT')
        this.isShow = true
      }
    },
    getWelcomeMessage: function (callback) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid
      }

      vm.welcome_message.message = null
      vm.welcome_message.generics = [
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: true
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        },
        {
          image_url: null,
          title: '',
          subtitle: '',
          buttons: [],

          enable: false
        }
      ]
      vm.welcome_message.type = 'message'
      api.getWelcomeMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          return
        }
        if (response.data) {
          vm.welcome_message.type = response.data.type
          vm.welcome_message.message = response.data.message_text ? response.data.message_text : ''

          if (
            response.data.message &&
            typeof response.data.message === 'object' &&
            response.data.message.length > 0
          ) {
            $.each(response.data.message, function (index, val) {
              vm.welcome_message.generics[index] = val
            })
          }

          if (
            response.data.message_quickreplies &&
            response.data.message_quickreplies !== '' &&
            response.data.message_quickreplies != null
          ) {
            vm.welcome_message.quick_reply = response.data.message_quickreplies.split(',')
          } else {
            vm.welcome_message.quick_reply = []
          }
        }
        callback()
      })
    },
    expandAll: function () {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', true)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', true)
    },
    collapseAll: function () {
      this.intents.forEach((el, index) => {
        this.$set(this.intents[index], 'isShow', false)
      })
      this.$set(this.default_comment_to_inbox, 'isShow', false)
    },
    onUpdateIntent: function (payload) {
      var vm = this
      $.each(vm.intents, function (index, intent) {
        if (intent.id == payload.id) {
          vm.intents[index] = payload
          return false
        }
      })
    }
  },
  watch: {
    selectedBot: function (newVal, oldVal) {
      // this.getIntent(function() {})
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.edittingIntent && this.$store.state.edittingIntent.length > 0) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        this.$store.commit('CLEAR_EDITTING_INTENT')
        next()
      } else {
        next(false)
      }
    } else {
      this.$store.commit('CLEAR_EDITTING_INTENT')
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/intent/CommentToInbox.vue